var path = require('path');
if (!path.delimiter) path.delimiter = process.platform === 'win32' ? ';' : ':';
